//#region Imports and Global Definitions
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { StyleSheet, View, SafeAreaView, ScrollView, Image, KeyboardAvoidingView, Platform, TouchableOpacity, Dimensions, useWindowDimensions, Pressable } from 'react-native';
import { useTheme, useNavigation } from '@react-navigation/native';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../components/CustomInput';
import CustomDropDown from '../../../components/CustomDropDown/CustomDropdown';
import CustomButton from '../../../components/CustomButton';
import CustomCalendar from '../../../components/CustomCalendar/CustomCalendar';
import CustomText from '../../../components/CustomText/CustomText';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { useAccountContext } from '../../../hooks/useAccountContext';
import { useSignin } from '../../../hooks/useSignIn';
import axios from 'axios';
import { format } from "date-fns";
import { openFile } from '../../../components/Platform/fileViewer';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import { showMessage } from "react-native-flash-message";
import { ActivityIndicator } from 'react-native-paper';
import { Calendar, LocaleConfig } from 'react-native-calendars';
import { changeDateFromMMMDDYYYYToYYYYMMDD, changeDateFromYYYYMMDDToDDMMYYYY } from '../../../constants/FormatDate';
import KeyboardAwareContainer from '../../../components/Platform/KeyboardAwareContainer';
import { useSafeAreaInsets } from "react-native-safe-area-context";
import useRole from '../../../hooks/userRole';
import { TASK_OPTIONS, TASKS } from '../../../constants/Tasks';
import { DEFAULTPROFILE } from '../../../img/DefaultProfile';
import { documentPicker } from './Documentpicker/documentPicker';
import Modal from "react-native-modal";
var _ = require('lodash');
import {
    Menu,
    MenuOptions,
    MenuOption,
    MenuTrigger,
    renderers,
} from 'react-native-popup-menu';
// * Language 
import { useTranslation } from 'react-i18next';
import { CalendarLocale, getLocale, getMondayFirst } from '../../../constants/CalendarLocale';

import { useLeave } from '../../../hooks/useLeave';
import { useSettingsContext } from '../../../hooks/useSettingsContext';

// app size

const deviceHeight = Dimensions.get("window").height


//#endregion

const NewLeaveScreen = ({ leaveDetails, managerId, selectMyLeavesScreen, laaEmplId = '', laaCompany = '', setShowNewLeaveScreen = null, fetchSelectedEmplLeave = null }) => {

    const { GetLeaveTypes, GetLeaveReplacements, GetLeaveSubmitMessages } = useLeave();
    const { width, height } = useWindowDimensions();
    const isPlatformWeb = (Platform.OS === 'web' && width > 992 ? false : true);
    const { mandatoryReplacement } = useSettingsContext();
    //#region Const Definitions
    const { colors } = useTheme();
    const styles = makeStyles(colors, width, height, isPlatformWeb);
    const { refreshSignIn } = useSignin();
    const navigation = useNavigation();
    const { hasOptionAccess } = useRole();
    // * Language
    const { t, i18n } = useTranslation();
    const insets = useSafeAreaInsets();

    // assign calendar's locale based on selected language and device's location
    LocaleConfig.locales['en'] = CalendarLocale['en'];
    LocaleConfig.locales['gr'] = CalendarLocale['gr'];
    LocaleConfig.defaultLocale = i18n.language;

    const { username, user, dispatch, clientApi } = useAuthContext();
    const { account, managerEmployees, oasisParam } = useAccountContext();

    const typeRef = useRef(null);
    const tempRangeRef = useRef(null);
    const rangeRef = useRef(null);
    const durationRef = useRef(null);
    const linesRef = useRef(null);
    const replacementRef = useRef(null);
    const commentsRef = useRef(null);
    const attachmentsRef = useRef(null);
    const rangeTextRef = useRef(null);
    const typeMessageRef = useRef(null);
    const submitClickedRef = useRef(null);
    const configurationsRef = useRef(null);
    const viewLinesRef = useRef(null);
    const docAllowedRequiredRef = useRef(null);
    const employeeIdRef = useRef(null);
    const employeeCompanyRef = useRef(null);

    //* data from API
    const [types, setTypes] = useState([]);
    const [typesOptions, setTypesOptions] = useState([]);
    const [replacementsOptions, setReplacementsOptions] = useState([]);
    const [replacements, setReplacements] = useState([]);
    const [submitMessages, setSubmitMessages] = useState([]);
    const [managerEmployeesOptions, setManagerEmployeesOptions] = useState([]);

    //* data to be submitted
    const [type, setType] = useState(null);
    const [tempRange, setTempRange] = useState({}); // strings of format yyyy-MM-dd
    const [range, setRange] = useState({});         // strings of format yyyy-MM-dd
    const [rangeText, setRangeText] = useState(""); // strings of format dd/MM/yyyy
    const [duration, setDuration] = useState(0);
    const [durationFromAPI, setDurationFromAPI] = useState(0);
    const [lines, setLines] = useState([]);
    const [replacement, setReplacement] = useState(null);
    const [comments, setComments] = useState("");
    const [typeMessage, setTypeMessage] = useState(""); // warn user about type selected (to submit their timesheets...)
    const [attachments, setAttachments] = useState({});
    const [employeeId, setEmployeeId] = useState(null);

    //* needed for processing
    var typesArray = [];
    var replacementsArray = [];
    const [datePickerModalOpen, setDatePickerModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [submitClicked, setSubmitClicked] = useState(false);
    const [viewLines, setViewLines] = useState(false);
    const [editableDuration, setEditableDuration] = useState(false);
    const [finalLines, setFinalLines] = useState([]);
    const [docAllowedRequired, setDocAllowedRequired] = useState([{ allowed: "False" }]);

    //* validation errors
    const [typeError, setTypeError] = useState("");
    const [datesError, setDatesError] = useState("");
    const [durationError, setDurationError] = useState("");
    const [lineError, setLineError] = useState("");
    const [replacementError, setReplacementError] = useState("");
    const [commentsError, setCommentsError] = useState("");
    const [attachmentsError, setAttachmentsError] = useState("");
    const [calendarError, setCalendarError] = useState("");
    const [selectedEmployeeError, setSelectedEmployeeError] = useState("");

    //* Edit Leave
    const [editLeave, setEditLeave] = useState(false)
    const [leaveId, setLeaveId] = useState("")
    const editLeaveRef = useRef(false);
    const leaveIdRef = useRef("");

    // * People on Leave on Range of Dates 
    const [teamLeavesOnRange, setTeamLeavesOnRange] = useState([]);
    //#endregion

    //#region Custom Calendar Creation for New Leave
    function HelperCalendar(props) {
        return (
            <CustomCalendar
                calendarType={'RangePicker'}
                setRange={setTempRange}
                range={tempRange}
            />
        );
    };

    const onDatePickerModalConfirm = () => {
        setCalendarError("");
        // only one date has been selected, so set endDate as startDate
        if (!typeRef.current) {
            setCalendarError(t('common:errSelectTypeBeforeDate'));
        }
        else if (tempRangeRef.current.startDate && !tempRangeRef.current.endDate) {
            let newRange = { ...tempRange, ...{ endDate: tempRangeRef.current.startDate } };
            setRange(newRange);
            setDatePickerModalOpen(false);
        } else if (!tempRangeRef.current.startDate) {
            setCalendarError(t('common:errCalendar'));
        }
        else {
            setRange(tempRangeRef.current);
            setDatePickerModalOpen(false);
        };
    };

    const onDatePickerModalDismiss = () => {
        setDatePickerModalOpen(false);
    };
    //#endregion

    //#region Navigation
    useEffect(() => {
        laaEmplId === '' && navigation.setOptions({
            title: managerId ? t('navigate:NLE') : (leaveDetails ? t('navigate:EL') : t('navigate:NL'))
        });
    }, []);
    //#endregion

    //#region UseEffect
    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );

    // * Edit Leave
    useEffect(() => {
        editLeaveRef.current = editLeave
    }, [editLeave]);
    useEffect(() => {
        leaveIdRef.current = leaveId
    }, [leaveId]);

    useEffect(() => {
        // type options for dropdown
        types.map((item) =>
            typesArray.push({ label: item.description, value: item.aCode })
        );
        setTypesOptions(typesArray);
    }, [types]);
    useEffect(() => {
        // replacement options for dropdown
        replacements.map((item) =>
            replacementsArray.push({ label: item.description, value: item.id })
        );
        setReplacementsOptions(replacementsArray);
    }, [replacements])
    useEffect(() => {
        typeRef.current = type;
        clearCloseLines();
        getDuration();
        if (typeRef.current !== null) {
            // show type message
            if (submitMessages.find(obj => obj.aCode === typeRef.current))
                var messageFound = submitMessages.find(obj => obj.aCode === typeRef.current).message;
            if (messageFound !== undefined && messageFound !== "") {
                setTypeMessage(messageFound);
            } else {
                setTypeMessage("");
            };
            // get attachment settings from API
            axios
                .get(`${clientApi}api/leaves/DocAllowedRequired`,
                    {
                        headers: { Authorization: `Bearer ${user.token}` },
                        params: {
                            employeeID: employeeIdRef.current,
                            aCode: type
                        }
                    })
                .then(response => {
                    setDocAllowedRequired(response.data);
                })
                .catch(error => {
                    axiosErrorHandling(error);
                });
        } else {
            setTypeMessage("");
        };
        if (submitClickedRef.current) {
            validateType();

        };
    }, [type]);
    useEffect(() => {
        durationRef.current = duration;
        if (submitClickedRef.current) {
            validateDuration();
            validateAttachments();
        };
        if (durationRef.current !== 0) {
            setEditableDuration(true);
            validateDuration();
        }
        else
            setEditableDuration(false)
        validateDuration();
    }, [duration]);
    useEffect(() => {
        linesRef.current = lines;
    }, [lines]);

    useEffect(() => {

    }, [durationError]);
    useEffect(() => {
        replacementRef.current = replacement;
        if (submitClickedRef.current) {
            validateReplacement();
        };
    }, [replacement]);
    useEffect(() => {
        commentsRef.current = comments;
        if (submitClickedRef.current) {
            validateComments();
        };
    }, [comments]);
    useEffect(() => {
        attachmentsRef.current = attachments;
        if (submitClickedRef.current) {
            validateAttachments();
        };
    }, [attachments]);
    useEffect(() => {
        rangeTextRef.current = rangeText;
        if (submitClickedRef.current) {
            validateDates();
        };
    }, [rangeText]);
    useEffect(() => {
        typeMessageRef.current = typeMessage;
    }, [typeMessage]);
    useEffect(() => {
        rangeRef.current = range;
        // if calendar is closed and range has been selected
        if (!datePickerModalOpen && Object.keys(range).length === 2) {
            clearCloseLines();
            getDuration();
            getTeamMembersOnLeave(range.startDate, range.endDate);
            const hasStartDate = range.startDate && range.startDate.trim() !== '';
            const hasEndDate = range.endDate && range.endDate.trim() !== '';

            if (hasStartDate && hasEndDate) {
                setRangeText(`${changeDateFromYYYYMMDDToDDMMYYYY(range.startDate)} - ${changeDateFromYYYYMMDDToDDMMYYYY(range.endDate)}`);
            } else if (hasStartDate) {
                setRangeText(changeDateFromYYYYMMDDToDDMMYYYY(range.startDate));
            } else {
                setRangeText('');
            }
        };
    }, [range, datePickerModalOpen]);
    useEffect(() => {
        tempRangeRef.current = tempRange;
        setRange(tempRange)
    }, [tempRange]);
    useEffect(() => {
        if (submitClickedRef !== null && submitClicked === false) {
            clearValues();
        };
        submitClickedRef.current = submitClicked;
    }, [submitClicked]);
    useEffect(() => {
        viewLinesRef.current = viewLines;
    }, [viewLines]);
    useEffect(() => {
        docAllowedRequiredRef.current = docAllowedRequired;
        validateAttachments();
    }, [docAllowedRequired]);
    useEffect(() => {
        if (managerId) {
            employeeIdRef.current = employeeId;
            if (employeeId) {
                if (laaCompany === '') {
                    // * This is for the onbehalf of manager of employees is loaded on login with account
                    var employeeObject = managerEmployees.find((employee) => employee.employeeId == employeeId);
                    employeeCompanyRef.current = employeeObject?.company;
                }
                else {
                    //* this is for leave application approval. All leaves loaded are loaded with company 
                    employeeCompanyRef.current = laaCompany;
                }
            } else {
                employeeCompanyRef.current = null;
            };
        } else {
            if (account?.employeeId)
                employeeIdRef.current = account.employeeId;
            if (account.company)
                employeeCompanyRef.current = account.company;
        };
        fetchInitialData();
        if (submitClickedRef.current) {
            validateEmployeeId();
        };
    }, [employeeId]);

    // when navigating from edit leave to new leave, clear values
    useEffect(() => {
        if (!leaveDetails) {
            clearValues();
        };
    }, [leaveDetails]);

    // when navigating from new leave to new leave for employee, clear values
    useEffect(() => {
        if (managerId) {
            laaEmplId === '' ?
                setEmployeeId(null) : setEmployeeId(laaEmplId)
        };
    }, [managerId]);

    /* needed to avoid memory leaks/warnings
       when navigating through different pages */
    useEffect(() => {
        return () => {
            clearValues();
        };
    }, []);
    // useEffect(() => {
    // Use `setOptions` to update the button that we previously specified
    // Now the button includes an `onPress` handler
    // navigation.setOptions({
    //     headerRight: () => (
    //         <CustomButton
    //             text={t('common:submit')}
    //             onPress={submitApplication}
    //             disabled={isLoading ? true : false}
    //             type={managerId ? isLoading ? 'SUBMIT_DISABLED_EXTRA_MARGIN' : 'TOPRIGHT_EXTRA_MARGIN' : isLoading ? 'SUBMIT_DISABLED' : 'TOPRIGHT'}
    //         />
    //     ),
    // });
    // }, [navigation, isLoading]);

    useEffect(() => {
        // * Check if leave created by manager for employee
        if (managerId && laaEmplId === '') {
            if (managerEmployees.length > 0) {
                setSelectedEmployeeError("");
                var managerEmployeesArray = [];
                managerEmployees.map((item) =>
                    managerEmployeesArray.push({ label: `${item.name} - ${item.employeeId}`, value: item.employeeId })
                );
                setManagerEmployeesOptions(managerEmployeesArray);
            } else {
                setSelectedEmployeeError("No Employees Found");
            };
        } else {
            fetchInitialData();
            // After Loading all the data for new leave check if edit leave
            // * Route Params for Edit Leave
            if (leaveDetails) {
                var convertedStartDate = changeDateFromMMMDDYYYYToYYYYMMDD(leaveDetails.startDate);
                var convertedEndDate = changeDateFromMMMDDYYYYToYYYYMMDD(leaveDetails.endDate);
                setEditLeave(leaveDetails.editLeave);
                setType(leaveDetails.acode);
                setRange({ startDate: laaEmplId === '' ? convertedStartDate : leaveDetails.startDate, endDate: laaEmplId === '' ? convertedEndDate : leaveDetails.endDate });
                setTempRange({ startDate: laaEmplId === '' ? convertedStartDate : leaveDetails.startDate, endDate: laaEmplId === '' ? convertedEndDate : leaveDetails.endDate });
                setRangeText(`${changeDateFromYYYYMMDDToDDMMYYYY(laaEmplId === '' ? convertedStartDate : leaveDetails.startDate)} - ${changeDateFromYYYYMMDDToDDMMYYYY(laaEmplId === '' ? convertedEndDate : leaveDetails.endDate)}`);
                setComments(leaveDetails.comments);
                setLeaveId(leaveDetails.leaveId);
                setReplacement(leaveDetails.replacementId);
            };
        };
    }, []);
    //#endregion

    const fetchInitialData = async () => {
        if (employeeIdRef.current && employeeCompanyRef.current) {
            setIsLoading(true);
            try {
                const typesData = await GetLeaveTypes(employeeIdRef.current, employeeCompanyRef.current);
                setTypes(typesData || []);

                const replacementsData = await GetLeaveReplacements(employeeIdRef.current);
                setReplacements(replacementsData || []);

                const submitMessagesData = await GetLeaveSubmitMessages(employeeCompanyRef.current);
                setSubmitMessages(submitMessagesData || []);
            } catch (error) {
                // Optionally handle errors here if not handled inside the API functions
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const showInDays = () => {
        return (oasisParam.leaveUnit === "D");
    }

    const fetchDuration = async (startDate, endDate) => {
        try {
            if (typeRef.current === '' || typeRef.current === null)
                return;
            const durationResponse = await axios.get(`${clientApi}api/leaves/Duration`, {
                headers: { Authorization: `Bearer ${user.token}` },
                params: {
                    EmployeeId: laaEmplId !== '' ? laaEmplId : employeeIdRef.current,
                    StartDate: startDate,
                    EndDate: endDate,
                    Abscode: typeRef.current,
                }
            });
            setDuration(durationResponse.data);
            setDurationFromAPI(durationResponse.data);

            const leaveLinesResponse = await axios.get(`${clientApi}api/leaves/LeaveLines`, {
                headers: { Authorization: `Bearer ${user.token}` },
                params: {
                    startDate: startDate,
                    endDate: endDate,
                    aCode: typeRef.current,
                    emplId: laaEmplId !== '' ? laaEmplId : employeeIdRef.current,
                    currentUser: employeeIdRef.current,
                }
            });
            setLines(leaveLinesResponse.data.map(line => ({
                ...line,
                duration: line.duration.toFixed(1),
                totalduration: line.totalduration.toFixed(1)
            })));
        } catch (error) {
            axiosErrorHandling(error);
        }
    };

    const getDuration = () => {
        if (typeRef.current !== null && rangeRef.current.endDate) {
            // set datetime timezones to our database's timezone (00:00:00)
            let startDate = new Date(rangeRef.current.startDate);
            const offset = startDate.getTimezoneOffset();
            startDate = new Date(startDate.getTime() - (offset * 60 * 1000));
            startDate = startDate.toISOString().split('T')[0];

            let endDate = new Date(rangeRef.current.endDate);
            const offsetEndDate = endDate.getTimezoneOffset();
            endDate = new Date(endDate.getTime() - (offsetEndDate * 60 * 1000));
            endDate = endDate.toISOString().split('T')[0];

            fetchDuration(startDate = startDate, endDate = endDate);

        };
    };

    const getTeamMembersOnLeave = async (startDate, endDate) => {
        await axios.get(`${clientApi}api/Employee/UpcomingTeamLeavesFYSpecificDates`, {
            headers: { Authorization: `Bearer ${user.token}` },
            params: {
                Username: username,
                StartDate: changeDateFromYYYYMMDDToDDMMYYYY(startDate),
                EndDate: changeDateFromYYYYMMDDToDDMMYYYY(endDate)
            }
        })
            .then((response) => {
                // update the Items context
                setTeamLeavesOnRange(response.data)
            })
            .catch((error) => {
                console.log(error)
                if (error.response.status === 401) {
                    refreshSignIn(user, clientApi)
                }
            })
    }

    const pickDocument = useCallback(async () => {
        //* select attachment
        // TODO: get size from oasis settings (DB)
        const maxSize = 30 * 1048576
        // TODO: check if types are correct on ios
        // android types: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
        // ios types: https://developer.apple.com/documentation/uniformtypeidentifiers/system-declared_uniform_type_identifiers?language=objc

        try {
            let attachmentsCopy = _.cloneDeep(attachmentsRef.current);  // existing attachments
            const files = await documentPicker();
            files.map((file) => {
                // if size allowed
                if (file.size < maxSize) {
                    let keyOfFile = Object.keys(attachmentsCopy).find(key => attachmentsCopy[key]["name"] === file.name);
                    if (!keyOfFile) {
                        // attachment is not in object yet -> add it
                        attachmentsCopy[`file${Object.keys(attachmentsCopy).length}`] = file;
                    } else {
                        // attachment already in object -> update it
                        attachmentsCopy[keyOfFile] = file;
                    };
                } else {
                    // file is too large
                    showMessage({
                        message: t('common:selectAttach'),
                        type: "warning",
                        duration: 3000,
                        position: "top",
                        ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 } }),
                        ...(Platform.OS === 'web' ? {} : { floating: true, })
                    });
                };
            });

            setAttachments(attachmentsCopy);

        } catch (error) {
            console.error(error);
        };
    }, []);
    //#endregion

    //#region Helper Functions
    const CreateDivider = () => {
        return (
            <View
                style={{
                    borderBottomColor: colors.text_primary,
                    marginVertical: 10,
                    borderBottomWidth: StyleSheet.hairlineWidth,
                }}
            />
        );
    };

    const showAttachments = () => {
        //* the attachments section to be shown/hidden
        return (
            <View>
                {Object.entries(attachments)
                    .map(([key, value]) =>
                        <View key={key} style={styles.attachmentContainer}>
                            <View style={styles.attachmentIcons}>
                                <Ionicons
                                    name="document-outline"
                                    style={styles.icons}
                                />
                            </View>
                            <View style={styles.attachmentNameContainer}>
                                <CustomText style={styles.attachmentNameText}>{value.name}</CustomText>
                            </View>
                            <View style={styles.attachmentIcons}>
                                <Menu
                                    renderer={renderers.SlideInMenu}
                                    style={styles.attachmentMenu}
                                >
                                    <MenuTrigger>
                                        <Ionicons
                                            name="ellipsis-vertical"
                                            style={styles.dotsIcon}
                                        />
                                    </MenuTrigger>
                                    <MenuOptions customStyles={optionsStyles}>
                                        {/* <MenuOption onSelect={() => openAttachment(key)} customStyles={openOptionStyles} text={t('common:open')}>
                                        </MenuOption> */}
                                        {/* <Divider style={styles.dividerStyle} /> */}
                                        {CreateDivider()}
                                        <MenuOption onSelect={() => removeAttachment(key)} customStyles={removeOptionStyles} text={t('common:remove')}>
                                        </MenuOption>
                                        {/* <Divider /> */}
                                        {CreateDivider()}
                                        <MenuOption customStyles={cancelOptionStyles} text={t('common:cancel')}>
                                        </MenuOption>
                                    </MenuOptions>
                                </Menu>
                            </View>
                        </View>
                    )}
            </View>
        );
    };

    // TODO
    const openAttachment = (key) => {
        console.log(attachmentsRef.current[key].uri);
        const attachment = attachmentsRef.current[key];
        openFile(Platform.OS === 'web' ? attachment : attachment.uri, attachment.mimeType || attachment.type)
            .then(() => {
                console.log("success");
            })
            .catch((error) => {
                // console.log(error);
                axiosErrorHandling(error);
            });
    };

    const removeAttachment = (key) => {
        //* remove attachment from array
        let attachmentsCopy = _.cloneDeep(attachmentsRef.current);
        delete attachmentsCopy[key];
        let i = 0;
        for (const [key, value] of Object.entries(attachmentsCopy)) {
            if (key !== `file${i}`) {
                Object.defineProperty(attachmentsCopy, `file${i}`,
                    Object.getOwnPropertyDescriptor(attachmentsCopy, key));
                delete attachmentsCopy[key];
            };
            i += 1;
        };
        setAttachments(attachmentsCopy);
    };

    // TODO: check that string contains only numbers/decimals on web
    const onChangeDurationManually = (duration) => {
        //* when manually changing duration on duration input box
        clearCloseLines();
        if (duration != "" && duration >= 0 && duration <= durationFromAPI && duration % 0.5 === 0) {
            setDurationError("");
            let newLines = JSON.parse(JSON.stringify(linesRef.current));
            newLines.map((item, index) => {
                if (duration >= parseFloat(item.totalduration)) {
                    duration -= parseFloat(item.totalduration);
                    newLines[index].duration = parseFloat(item.totalduration).toFixed(1);
                } else {
                    newLines[index].duration = parseFloat(duration).toFixed(1);
                    duration = 0;
                }
            });
            setLines(newLines);
        } else if (editableDuration && (duration !== 0 || duration === "")) {
            console.log('here')
            setDurationError(t('common:errDur'));
        }
        else if (editableDuration)
            setDurationError(t('common:errDur0'));

    };

    const setLineDuration = (index, duration) => {
        //* when changing line duration
        const newChange = JSON.parse(JSON.stringify(finalLines));
        newChange[index].duration = duration;
        setFinalLines(newChange);
    };

    const confirmLineChanges = () => {
        //* when √ is clicked to save line changes
        let errorFound = false;
        let totalDuration = 0;
        var dur;
        finalLines.map((item) => {
            if (!(parseFloat(item.duration) >= 0 && parseFloat(item.duration) <= parseFloat(item.totalduration) && parseFloat(item.duration) % 0.5 === 0 && editableDuration)) {
                errorFound = true;
            }
            dur = item.duration;
        });
        if (errorFound && dur === 0)
            setLineError(t('common:errDur0'));
        else if (errorFound)
            setLineError(t('common:errDur'));
        else {
            setLineError("");
            setLines(finalLines.map(line => {
                return { ...line, duration: parseFloat(line.duration).toFixed(1) }
            }));
            finalLines.map((item) => {
                totalDuration = parseFloat(totalDuration) + parseFloat(item.duration);
            });
            setDuration(parseFloat(totalDuration.toFixed(1)));
            clearCloseLines();
        };
    };

    const discardLineChanges = () => {
        //* when X is clicked to discard line changes
        clearCloseLines();
    };

    const clearCloseLines = () => {
        setFinalLines([]);
        setLineError("");
        setViewLines(false);
    };

    const updateLines = () => {
        //* the lines section to be shown/hidden
        if (finalLines.length === 0) {
            setFinalLines(JSON.parse(JSON.stringify(linesRef.current)));
        };
        return (
            <View style={{ marginTop: '5%', marginBottom: '-3%', }}>
                <ScrollView nestedScrollEnabled={true} showsVerticalScrollIndicator={true} persistentScrollbar={true} style={styles.linesScrollView}>
                    {finalLines.map((item, index) =>
                        <View key={index} style={styles.lineContainer}>
                            <View style={styles.lineDateContainer}>
                                <CustomText style={styles.lineDateText}>{format(new Date(item.linedate), "dd/MM/yyyy").toString()} - {item.nameofday}</CustomText>
                                {item.details !== "" && <CustomText style={styles.lineDetailsText}>{item.details}</CustomText>}
                            </View>
                            <View style={styles.lineDurationContainer}>
                                <CustomInput
                                    type='leaveLinesRowFieldText'
                                    value={item.duration}
                                    setValue={(duration) => setLineDuration(index, duration)}
                                    keyboardType='numeric'
                                    containerStyle={{ paddingHorizontal: 5 }}
                                />
                            </View>
                            <View style={styles.lineTotalDurationContainer}>
                                <CustomText style={styles.lineTotalDurationText}> / {item.totalduration}</CustomText>
                            </View>
                        </View>
                    )}
                </ScrollView >
                <View style={styles.linesErrorConfirmDiscardView}>
                    <View style={styles.linesErrorContainer}>
                        <CustomLabel
                            type='error'
                            value={lineError}
                        />
                    </View>
                    <View style={styles.linesConfirmDiscardView}>
                        <View style={styles.linesDiscardView}>
                            <Ionicons
                                name="close-outline"
                                style={[styles.icons, { color: '#ff0000' }]}
                                onPress={() => discardLineChanges()}
                            />
                        </View>
                        <View>
                            <Ionicons
                                name="checkmark-outline"
                                style={[styles.icons, { color: '#00b800' }]}
                                onPress={() => confirmLineChanges()}
                            />
                        </View>
                    </View>
                </View>
            </View >
        )
    };

    const clearValues = () => {
        // values
        setRange({});
        setTempRange({});
        setRangeText("");
        setType(null);
        setDuration(0);
        setDurationFromAPI(0);
        setReplacement(null);
        setComments("");
        setLines([]);
        setTypeMessage("");
        setDatePickerModalOpen(false);
        setEditableDuration(false);
        setIsLoading(false);
        setSubmitClicked(false);
        setFinalLines([]);
        setViewLines(false);
        setAttachments({});
        setDocAllowedRequired([{ allowed: "False" }]);
        setEmployeeId(null);
        setTeamLeavesOnRange([]);
        // errors
        setTypeError("");
        setDatesError("");
        setDurationError("");
        setLineError("");
        setReplacementError("");
        setCommentsError("");
        setAttachmentsError("");
        setCalendarError("");
        setSelectedEmployeeError("");
    };
    //#endregion

    //#region Validation
    const validateType = () => {
        if (!typeRef.current) {
            setTypeError(t('common:errRequired'));
            return false;
        } else {
            setTypeError("");
            return true;
        };
    };

    const validateDates = () => {
        if (rangeTextRef.current === "") {
            setDatesError(t('common:errRequired'));
            return false;
        } else {
            setDatesError("");
            return true;
        };
    };

    const validateDuration = () => {
        if (durationRef.current === 0 && durationFromAPI !== 0) {
            setDurationError(t('common:errDur0'));
            return false;
        } else {
            setDurationError("");
            return true;
        };
    };

    const validateReplacement = () => {
        if (oasisParam.isReplacementRequired && !replacementRef.current && replacementsOptions.length > 0) {
            setReplacementError(t('common:errRequired'));
            return false;
        } else {
            setReplacementError("");
            return true;
        };
    };

    const validateComments = () => {
        if (oasisParam.isCommentsRequired && commentsRef.current === "") {
            setCommentsError(t('common:errRequired'));
            return false;
        } else {
            setCommentsError("");
            return true;
        };
    };

    const validateAttachments = () => {
        if (docAllowedRequiredRef.current[0].required === "True" && parseInt(durationRef.current.toString(), 10) >= parseInt(docAllowedRequiredRef.current[0].requiredAfterUnits, 10) && Object.keys(attachmentsRef.current).length === 0) {
            setAttachmentsError(t('common:errRequired'));
            return false;
        } else {
            setAttachmentsError("");
            return true;
        };
    };

    const validateEmployeeId = () => {
        if (!employeeIdRef.current) {
            setSelectedEmployeeError(t('common:errRequired'));
            return false;
        } else {
            setSelectedEmployeeError("");
            return true;
        };
    };

    const validateFields = () => {
        if (!validateType() | !validateDates() | !validateDuration() | !validateReplacement() | !validateComments() | !validateAttachments() | !validateEmployeeId()) {
            return false;
        }
        return true;
    };

    // TODO
    function axiosErrorHandling(error) {
        try {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // If API Code then object else string 
                showMessage({
                    message: error.response.data.includes("There is an error with your approvers.") ? t('common:errApprover') : error.response.data,
                    type: "danger",
                    duration: 10000,
                    position: "top",
                    ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 } }),
                    ...(Platform.OS === 'web' ? {} : { floating: true, })
                });
                if (error.response.data.includes("There is an error with your approvers."))
                    // selectMyLeavesScreen()
                    return;
                // console.log(error);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error: ', error.message);
            };
        }
        // * API Error Codes are objects not strings 
        //! SHould be all the same but for another time
        catch (e) {
            showMessage({
                message: 'Please contact your administrator',
                type: "danger",
                duration: 10000,
                position: "top",
                ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 } }),
                ...(Platform.OS === 'web' ? {} : { floating: true, })
            });
        }
    };

    //#endregion

    const submitApplication = async (e) => {
        e.preventDefault();
        setSubmitClicked(true);

        if (!validateFields()) {
            showMessage({
                message: t('common:errAllFields'),
                type: "danger",
                duration: 3000,
                position: "top",
                ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 } }),
                ...(Platform.OS === 'web' ? {} : { floating: true, })
            });
            return;
        }

        setIsLoading(true);

        const data = new FormData();
        for (const [key, value] of Object.entries(attachmentsRef.current)) {
            data.append(key, value);
        }

        const appendCommonData = (duration, lines) => {
            data.append('employeeID', employeeIdRef.current);
            data.append('company', employeeCompanyRef.current);
            data.append('startDate', changeDateFromYYYYMMDDToDDMMYYYY(rangeRef.current.startDate));
            data.append('endDate', changeDateFromYYYYMMDDToDDMMYYYY(rangeRef.current.endDate));
            data.append('aCode', typeRef.current);
            data.append('duration', duration.toString());
            data.append('replacement', replacementRef.current);
            data.append('comments', commentsRef.current);
            data.append('leaveLines', JSON.stringify(lines));
            data.append('editLeave', editLeaveRef.current);
            data.append('leaveId', leaveIdRef.current);
            data.append('applicantID', managerId ? managerId : account.employeeId);
        };

        try {
            if (docAllowedRequiredRef.current[0].allowed === "False" && Object.keys(attachmentsRef.current).length !== 0) {
                setAttachments({});
            }

            appendCommonData(durationRef.current, linesRef.current);

            const submitResponse = await axios.post(`${clientApi}api/leaves/Submit`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${user.token}`
                }
            });

            if (submitResponse.status === 200) {
                showMessage({
                    message: t('common:succLA'),
                    type: "success",
                    position: "top",
                    ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 } }),
                    ...(Platform.OS === 'web' ? {} : { floating: true, })
                });

                //* This is for LAA, once the leave is submitted succesfuly show list of leaves and refresh as well in LAA screen (HR -> Utilities -> Leave Admin)
                laaEmplId !== '' && fetchSelectedEmplLeave();
                laaEmplId !== '' && setShowNewLeaveScreen(false);

            } else {
                showMessage({
                    message: submitResponse,
                    type: "danger",
                    duration: 10000,
                    position: "top",
                    ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 } }),
                    ...(Platform.OS === 'web' ? {} : { floating: true, })
                });
            }

            setSubmitClicked(false);
            setIsLoading(false);
            laaEmplId === '' && navigation.goBack();
        } catch (error) {
            axiosErrorHandling(error);
            setIsLoading(false);
        }
    };

    return (
        <KeyboardAwareContainer
            style={{ flex: 1 }}
            contentContainerStyle={{
                flexGrow: 1,
                paddingBottom: Math.max(insets.bottom + 24, 40),
            }}
            enableOnAndroid
            enableAutomaticScroll
            keyboardShouldPersistTaps="handled"
            extraScrollHeight={Platform.OS !== 'web' ? 220 : 200}
            showsVerticalScrollIndicator={false}
        >
            <SafeAreaView style={styles.mainView}>
                {/* if managerid, then display New Request for Employee label */}
                {managerId &&
                    <CustomLabel
                        value={t('common:NLE')}
                        type='MINORTITLE'
                    />
                }
                {/* else if edit leave, then display Edit Request label */}
                {leaveDetails &&
                    <CustomLabel
                        value={t('navigate:EL')}
                        type='MINORTITLE'
                    />
                }
                {/* else, display New Request label */}
                {!managerId && !leaveDetails &&
                    <CustomLabel
                        value={t('navigate:NL')}
                        type='MINORTITLE'
                    />
                }

                {/* split web view in two columns */}
                <View style={!isPlatformWeb && styles.webColumnsContainer}>
                    <View style={!isPlatformWeb && styles.webColumnLeft}>
                        {(!managerId || (managerId && employeeId !== null && employeeId !== "")) && < CustomLabel
                            value={t('common:LDs')}
                            type='CARDTITLE'
                            iconName="leaf"
                            sz={20}
                        />}
                        {(!managerId || (managerId && employeeId !== null && employeeId !== "")) && CreateDivider()}
                        {/* if application by manager for employee, only show employee dropdown first */}
                        {managerId && <>
                            <CustomLabel
                                value={t('common:employee')}
                                type='NEWREQUESTLABEL'
                            />
                            {laaEmplId === '' ?
                                <View style={{ maxHeight: 100 }}>
                                    <CustomDropDown
                                        type='FULL'
                                        defValue={employeeId}
                                        options={managerEmployeesOptions}
                                        setValue={setEmployeeId}
                                    />
                                </View> :
                                <CustomLabel
                                    value={laaEmplId}
                                    type='NEWREQUESTLABEL'
                                />}
                            <CustomLabel
                                type='error'
                                value={selectedEmployeeError} />
                        </>
                        }
                        {/* employee selected, or application by employee */}
                        {(!managerId || (managerId && employeeId !== null && employeeId !== "")) &&
                            <>
                                {/* Leave Type */}
                                <CustomLabel
                                    value={`${t('common:LT')}${t('common:asterisk')}`}
                                    type='NEWREQUESTLABEL'
                                />
                                <CustomDropDown
                                    type='FULL'
                                    defValue={type}
                                    options={typesOptions}
                                    setValue={setType}
                                />

                                {typeError !== "" && <CustomLabel
                                    type='error'
                                    value={typeError} />}

                                {/* Leave Dates */}
                                <CustomLabel
                                    value={`${t('common:LD')}${t('common:asterisk')}`}
                                    type='NEWREQUESTLABEL'
                                />
                                {!isPlatformWeb ?
                                    <View style={{
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}>
                                        <CustomInput
                                            type='FULL'
                                            placeholder={t('common:selectDate')}
                                            value={rangeText}
                                            editable={false}
                                        />
                                        {datesError !== "" &&
                                            <CustomLabel
                                                type='error'
                                                value={datesError}
                                            />
                                        }
                                        {/* calendar view */}
                                        <View style={{
                                            height: Platform.OS === 'web' ? 285 : (height < 670 ? height * 60 / 100 : height * 0 / 100),
                                            width: Platform.OS === 'web' ? 485 : width * 90 / 100,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginTop: '4%',
                                            borderRadius: 10,
                                            borderWidth: 0,
                                            borderColor: colors.border_card,
                                            backgroundColor: colors.background_card,
                                            marginBottom: '-1%',
                                        }}>
                                            <HelperCalendar
                                                style={{
                                                    height: Platform.OS === 'web' ? 285 : (height < 670 ? height * 60 / 100 : height * 60 / 100),
                                                    width: Platform.OS === 'web' ? 485 : width * 90 / 100,
                                                    borderRadius: 10,
                                                }}
                                            />
                                        </View>
                                        <CustomButton
                                            text={t('common:selectDate')}
                                            onPress={() => {
                                                onDatePickerModalConfirm();
                                            }}
                                            type='SAVE_CALENDAR_DATES_WEB'
                                        />
                                        {calendarError !== "" &&
                                            <CustomLabel
                                                type='error'
                                                value={calendarError}
                                            />
                                        }
                                    </View>
                                    :
                                    <>
                                        {/* Mobile */}
                                        <Pressable
                                            onPress={() => setDatePickerModalOpen(true)}>
                                            <View style={styles.customInputIconContainer}>
                                                <View style={styles.customInputContainer}>
                                                    <CustomInput
                                                        type='FULL_INLINE'
                                                        placeholder={t('common:selectDate')}
                                                        value={rangeText}
                                                        editable={false}
                                                    />
                                                </View>
                                                <View style={styles.customIconContainer}>
                                                    <Ionicons
                                                        name="calendar-outline"
                                                        style={styles.icons}
                                                        onPress={() => setDatePickerModalOpen(true)}
                                                    />
                                                </View>
                                            </View>
                                        </Pressable>
                                        <Modal
                                            isVisible={datePickerModalOpen}
                                            hasBackdrop={true}
                                            backdropColor={colors.background_approved}
                                            backdropOpacity={0.9}
                                            deviceWidth={width}
                                            deviceHeight={deviceHeight}
                                            onBackdropPress={() => { onDatePickerModalDismiss() }}
                                            onRequestClose={() => { onDatePickerModalDismiss() }}
                                            transparent={true}
                                        >
                                            <TouchableOpacity
                                                style={styles.container}
                                                activeOpacity={1}
                                                onPressOut={() => { onDatePickerModalDismiss() }}
                                            >
                                                <View style={styles.modalContent}>
                                                    <HelperCalendar
                                                    />
                                                    <View style={{ marginBottom: '2%', }}>
                                                        {calendarError !== "" &&
                                                            <CustomLabel
                                                                type='error'
                                                                value={calendarError}
                                                            />
                                                        }
                                                    </View>
                                                    <CustomButton
                                                        text={t('common:submit')}
                                                        onPress={() => {
                                                            onDatePickerModalConfirm();
                                                        }}
                                                        type='BUTTON_SAVE'
                                                        isGradient={true}

                                                    />
                                                </View>
                                            </TouchableOpacity>
                                        </Modal>
                                        {datesError !== "" &&
                                            <CustomLabel
                                                type='error'
                                                value={datesError}
                                            />
                                        }
                                    </>
                                }

                                {/* Team Members on leave during same period */}
                                {teamLeavesOnRange.length > 0 &&
                                    <ScrollView style={styles.scrollview}>
                                        <CustomLabel
                                            type='NEWREQUESTLABELWARNING'
                                            value={hasOptionAccess(TASKS.ALLEMPLOYEETASKS, TASK_OPTIONS.MYTEAM) ? t('common:teamOnLeave') : t('common:TM')}
                                        />
                                        {hasOptionAccess(TASKS.ALLEMPLOYEETASKS, TASK_OPTIONS.MYTEAM) && teamLeavesOnRange.map((teamMember, index) => {
                                            return (
                                                <View
                                                    key={index}
                                                    style={[styles.TeamMemberRow, !isPlatformWeb && { width: '75%' }]}>
                                                    <Image
                                                        style={{
                                                            width: 30,
                                                            height: 30,
                                                            marginRight: '3%',
                                                            borderRadius: 100,
                                                            borderWidth: 1,
                                                            alignSelf: 'center',
                                                        }}
                                                        source={{ uri: `data:image/png;base64,${teamMember.photograph === '' || teamMember.photograph === undefined ? DEFAULTPROFILE : teamMember.photograph}` }}
                                                    />
                                                    <CustomLabel
                                                        value={teamMember.teammateName}
                                                        type='MINOR' />
                                                    <CustomLabel
                                                        value={range.startDate != range.endDate && `${teamMember.startDate} - ${teamMember.endDate}`}
                                                        type='MINORDATE' />
                                                </View>
                                            )
                                        })}
                                    </ScrollView>
                                }
                                {/* Replacement */}
                                {mandatoryReplacement &&
                                    <CustomLabel
                                        value={t('common:Rep')}
                                        type='NEWREQUESTLABEL'
                                    />
                                }
                                {mandatoryReplacement &&
                                    <CustomDropDown
                                        type='FULL'
                                        defValue={replacementRef.current}
                                        options={replacementsOptions}
                                        setValue={setReplacement}
                                    />
                                }
                                {replacementError !== "" && <CustomLabel
                                    type='error'
                                    value={replacementError} />}
                            </>
                        }
                    </View>

                    {/* Right Column for web */}
                    {(!managerId || (managerId && employeeId !== null && employeeId !== "")) &&
                        <View style={!isPlatformWeb && styles.webColumnRight}>
                            <View style={!isPlatformWeb && styles.webColumnRightDuration}>
                                {(!managerId || (managerId && employeeId !== null && employeeId !== "")) && < CustomLabel
                                    value={t('common:Dur')}
                                    type='CARDTITLE'
                                    iconName="timer-outline"
                                    sz={20}
                                />}
                                {(!managerId || (managerId && employeeId !== null && employeeId !== "")) && CreateDivider()}
                                {(!managerId || (managerId && employeeId !== null && employeeId !== "")) &&
                                    <>
                                        {/* Duration */}
                                        <CustomLabel
                                            value={`${t('common:Dur')} (${t('common:leaveUnit', { leaveUnit: i18n.language === "gr" ? !showInDays() ? "ώρες" : "ημέρες" : !showInDays() ? "hours" : "days" })})${t('common:asterisk')}`}
                                            type='NEWREQUESTLABEL'
                                        />
                                        <View style={styles.customInputIconContainer}>
                                            <View style={styles.customInputContainer} key={duration}>
                                                <CustomInput
                                                    type='FULL_INLINE'
                                                    placeholder={durationFromAPI.toFixed(1)}
                                                    defaultValue={duration.toFixed(1)}
                                                    setValue={(duration) => onChangeDurationManually(parseFloat(parseFloat(duration).toFixed(1)))}
                                                    keyboardType='numeric'
                                                    editable={editableDuration}
                                                />
                                            </View>
                                            <View style={styles.customIconContainer}>
                                                <Ionicons
                                                    name="alarm-outline"
                                                    style={styles.icons}
                                                    onPress={() => { if (durationRef.current !== 0 && durationError === "") setViewLines(true) }}
                                                />
                                            </View>
                                        </View>
                                        {durationError != "" && <CustomLabel
                                            type='error'
                                            value={durationError} />}
                                        {viewLines ? (updateLines()) : null}
                                    </>
                                }

                                {/* Attachments */}
                                {docAllowedRequired[0].required === "True" &&
                                    <>
                                        <View style={styles.customLabelIconContainer}>
                                            <View style={styles.customLabelContainer}>
                                                <CustomLabel
                                                    type='NEW_REQUEST_ATTACHMENTS'
                                                    value={t('common:attach')}
                                                />
                                            </View>
                                            <View style={styles.customIconContainerPaperclip}>
                                                <Ionicons
                                                    name="attach-outline"
                                                    style={styles.icons}
                                                    onPress={pickDocument}

                                                />
                                            </View>
                                        </View>
                                        <View style={Object.keys(attachments).length !== 0 ? styles.attachmentsExistView : styles.attachmentsNotExistView}>
                                            {Object.keys(attachments).length !== 0 ?
                                                (showAttachments()) :
                                                <CustomLabel
                                                    type='NEW_REQUEST_NO_ATTACHMENTS'
                                                    value={t('common:selectAttach')}
                                                />}
                                        </View>
                                        {attachmentsError !== "" &&
                                            <CustomLabel
                                                type='error'
                                                value={attachmentsError}
                                            />
                                        }
                                    </>
                                }
                            </View>
                            <View style={!isPlatformWeb && styles.webColumnRightComments}>
                                {(!managerId || (managerId && employeeId !== null && employeeId !== "")) && <CustomLabel
                                    value={t('common:Comm')}
                                    type='CARDTITLE'
                                    iconName="chatbubble-outline"
                                    sz={20}
                                />}
                                {(!managerId || (managerId && employeeId !== null && employeeId !== "")) && CreateDivider()}
                                {(!managerId || (managerId && employeeId !== null && employeeId !== "")) &&
                                    <>
                                        {/* Comments */}
                                        <View style={!isPlatformWeb ? { minHeight: 100 } : null}>
                                            <CustomInput
                                                type={Platform.OS === 'android' ? 'MULTILINE_ANDROID' : 'MULTILINE'}
                                                multiline={true}
                                                numberOfLines={Platform.OS === 'android' ? 3 : null}
                                                value={comments}
                                                setValue={setComments}
                                                placeholder={t('common:anyComm')}
                                            />
                                        </View>
                                        {commentsError !== "" &&
                                            <CustomLabel
                                                type='error'
                                                value={commentsError}
                                            />
                                        }
                                    </>
                                }

                                {/* Attachments */}
                                {docAllowedRequired[0].required === "True" &&
                                    <>
                                        <View style={styles.customLabelIconContainer}>
                                            <View style={styles.customLabelContainer}>
                                                <CustomLabel
                                                    type='NEW_REQUEST_ATTACHMENTS'
                                                    value={t('common:attach')}
                                                />
                                            </View>
                                            <View style={styles.customIconContainerPaperclip}>
                                                <Ionicons
                                                    name="attach-outline"
                                                    style={styles.icons}
                                                    onPress={pickDocument}

                                                />
                                            </View>
                                        </View>
                                        <View style={Object.keys(attachments).length !== 0 ? styles.attachmentsExistView : styles.attachmentsNotExistView}>
                                            {Object.keys(attachments).length !== 0 ?
                                                (showAttachments()) :
                                                <CustomLabel
                                                    type='NEW_REQUEST_NO_ATTACHMENTS'
                                                    value={t('common:selectAttach')}
                                                />}
                                        </View>
                                        {attachmentsError !== "" &&
                                            <CustomLabel
                                                type='error'
                                                value={attachmentsError}
                                            />
                                        }
                                    </>
                                }
                            </View>
                        </View>
                    }
                </View>

                {/* Leave Type Message */}
                {typeMessage !== "" &&
                    <View style={{ paddingBottom: 10 }}>
                        <CustomInput
                            type={'MULTILINE_LEAVE_MESSAGE'}
                            multiline={true}
                            value={typeMessage}
                            editable={false}
                        />
                    </View>
                }

                {/* Submit Button */}
                {(!managerId || (managerId && employeeId !== null && employeeId !== "")) &&
                    <View style={styles.buttonRow}>
                        {laaEmplId !== '' && <CustomButton
                            text={t('common:cancel')}
                            onPress={() => { setShowNewLeaveScreen(false) }}
                            type="BUTTON_CANCEL"
                            sz={20}
                        />}
                        <CustomButton
                            text={t('common:submit')}
                            isGradient={true}
                            onPress={submitApplication}
                            disabled={isLoading ? true : false}
                            // type={managerId ? isLoading ? 'SUBMIT_DISABLED_EXTRA_MARGIN' : 'TOPRIGHT_EXTRA_MARGIN' : isLoading ? 'SUBMIT_DISABLED' : 'TOPRIGHT'}
                            type={'BUTTON_SAVE'}
                        />
                    </View>
                }

                {/* When submit is clicked, disable interaction and show loading icon */}
                {isLoading &&
                    <View style={styles.loading}>
                        <ActivityIndicator animating={true} size='large' color="#86BC25" />
                    </View>
                }
            </SafeAreaView >
        </KeyboardAwareContainer >
    )
};

//#region Styles
const makeStyles = (colors, width, height, isPlatformWeb) => StyleSheet.create({
    mainView: {
        flex: 1,
        marginTop: "1%",
        marginHorizontal: Platform.OS === 'web' ? '2%' : '1%',
        justifyContent: 'center',
    },
    container: {
        flex: 1,
        marginHorizontal: -5,
        justifyContent: 'center',
        alignItems: 'center',
    },
    scroll: {
        flex: 1,
        width: '100%',
        height: '100%',
    },
    icons: {
        fontSize: 22,
        color: colors.text_primary,
        marginLeft: Platform.OS === 'web' ? 0 : 1
    },
    dotsIcon: {
        fontSize: 21,
        color: colors.text_primary
    },
    paperClipIcon: {
        fontSize: 22,
        color: colors.text_primary
    },
    loading: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#4a4a4a',
        height: '100%',
        opacity: 0.8,
        zIndex: 10000,
    },
    TeamMemberRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '5%',
        marginRight: '5%',
        marginTop: '2%',
    },
    linesScrollView: {
        maxHeight: 200,
        marginBottom: 7,
        marginHorizontal: '3%'
    },
    lineContainer: {
        flexDirection: 'row',
        backgroundColor: colors.background_card,
        borderRadius: 10,
        marginVertical: '1%',
        paddingHorizontal: 15,
        paddingVertical: 5,
        justifyContent: 'center'
    },
    lineDateContainer: {
        flex: 6,
        justifyContent: 'center'
    },
    lineDateText: {
        fontSize: 16,
        color: colors.text_primary
    },
    lineDetailsText: {
        fontSize: 12,
        color: colors.text_primary
    },
    lineDurationContainer: {
        flex: 3,
        alignItems: 'flex-end',
        justifyContent: 'center'
    },
    lineTotalDurationContainer: {
        flex: 1.2,
        justifyContent: 'center',
    },
    lineTotalDurationText: {
        textAlign: 'left',
        fontSize: 16,
        color: colors.text_primary
    },
    linesErrorConfirmDiscardView: {
        flexDirection: 'row',
        marginHorizontal: '3%'
    },
    linesErrorContainer: {
        flex: 9,
        justifyContent: 'center',
        alignItems: 'center'
    },
    linesConfirmDiscardView: {
        flex: 3,
        flexDirection: 'row',
        alignItems: 'flex-end'
    },
    linesDiscardView: {
        paddingRight: 25
    },
    attachmentContainer: {
        flexDirection: 'row',
        borderRadius: 10,
        marginHorizontal: '3%',
        marginVertical: '1%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    attachmentIcons: {
        flex: 0.7,
        alignItems: 'flex-start',
        color: colors.text_primary,
    },
    attachmentNameContainer: {
        flex: 7,
        alignItems: 'flex-start'
    },
    attachmentNameText: {
        fontSize: 16,
        color: colors.text_primary,
    },
    attachmentMenu: {
        alignSelf: 'flex-end',
    },
    scrollview: {
        margin: 10,

    },
    customInputIconContainer: {
        marginLeft: '3%',
        width: '92%',
        flexDirection: 'row',
        marginVertical: 5,
        marginBottom: '-2%',
    },
    customInputContainer: {
        width: isPlatformWeb ? '93%' : '90%',
        justifyContent: 'center',
        alignItems: 'flex-start',
        marginTop: 7
    },
    customIconContainer: {
        width: isPlatformWeb ? '7%' : '10%',
        justifyContent: 'center',
        alignItems: 'flex-end',
        left: 5,
    },
    customLabelIconContainer: {
        marginLeft: '3%',
        width: '94%',
        flexDirection: 'row',
        marginVertical: isPlatformWeb ? 0 : 5,
        marginTop: isPlatformWeb ? '4%' : '5%',
    },
    customLabelContainer: {
        width: '90%',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    customIconContainerPaperclip: {
        width: '10%',
        justifyContent: 'center',
        alignItems: 'flex-end',
        marginTop: isPlatformWeb ? 3 : 0,

    },
    attachmentsExistView: {
        borderColor: colors.border_card,
        borderWidth: 2,
        width: '94%',
        backgroundColor: colors.background_card,
        borderRadius: 10,
        marginHorizontal: '3%',
        marginVertical: isPlatformWeb ? 5 : 0,
        paddingVertical: isPlatformWeb ? 0 : 3,
        marginBottom: '-1%',
    },
    attachmentsNotExistView: {
        borderColor: colors.border_card,
        borderWidth: 2,
        width: '94%',
        backgroundColor: colors.background_card,
        borderRadius: 10,
        marginHorizontal: '3%',
        marginVertical: isPlatformWeb ? 5 : 0,
        paddingVertical: isPlatformWeb ? 0 : 3,
        marginBottom: '-1%',
    },
    modalContent: {
        width: '94%',
        backgroundColor: colors.background_card,
        borderRadius: 20,
        borderWidth: 3,
        borderColor: '#a1a1a1',
        padding: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonRow: {
        marginTop: 10,
        alignSelf: Platform.OS === 'web' ? 'flex-end' : 'center',
        flexDirection: 'row'
    },
    webColumnsContainer: {
        flex: 1,
        margin: 20,
        flexDirection: 'row',
        width: '100%',
    },
    webColumnLeft: {
        width: '60%',
        backgroundColor: colors.background_white,
        borderWidth: 1,
        borderColor: colors.border_card,
        borderRadius: 14,
        padding: 24,
        shadowColor: 'rgba(92, 143, 26, 1)',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.08,
        shadowRadius: 12,
        elevation: 3,
    },
    webColumnRight: {
        flex: 1,
        marginHorizontal: 10,
    },
    webColumnRightDuration: {
        backgroundColor: colors.background_white,
        marginBottom: 10,
        borderWidth: 1,
        borderColor: colors.border_card,
        borderRadius: 14,
        padding: 24,
        shadowColor: 'rgba(92, 143, 26, 1)',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.08,
        shadowRadius: 12,
        elevation: 3,
    },
    webColumnRightComments: {
        backgroundColor: colors.background_white,
        borderWidth: 1,
        borderColor: colors.border_card,
        borderRadius: 14,
        padding: 24,
        shadowColor: 'rgba(92, 143, 26, 1)',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.08,
        shadowRadius: 12,
        elevation: 3,
    },
});

const optionsStyles = {
    optionsContainer: {
        marginHorizontal: '3.5%',
        marginVertical: '-3%',
        borderRadius: 10,
    },
    optionWrapper: {
        height: 50,
        justifyContent: 'center',
    },
};

const openOptionStyles = {
    optionText: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 'bold'
    },
};

const removeOptionStyles = {
    optionText: {
        textAlign: 'center',
        fontSize: 16,
        color: '#dd3636',
    },
};

const cancelOptionStyles = {
    optionText: {
        textAlign: 'center',
        fontSize: 16,
    },
};
//#endregion

export default NewLeaveScreen;